import React from "react";
import { Tooltip } from "antd";
import { CrownFilled, LogoutOutlined } from "@ant-design/icons";
import { childKeys, isModuleActive } from "../../navPaths";
import styles from "./styles.module.css";

const NavRail = ({
  items,
  openKey,
  onOpen,
  onNavigate,
  onLocked,
  onLogout,
  logoutLoading,
  pathname,
}) => (
  <nav className={styles.rail} data-tut="start_tour_logo" data-tour="nav-rail">
    <Tooltip title="داشبورد" placement="left">
      <button
        type="button"
        className={styles.logo}
        aria-label="داشبورد"
        onClick={() => onNavigate("dashboard")}
      >
        <img width={26} height={26} src="/logo-bg-trans.png" alt="تسکامون" />
      </button>
    </Tooltip>

    <div className={`${styles.items} ds-scroll-compact`}>
      {items.map((item) => {
        if (!item || typeof item.key !== "string") return null;
        const active = isModuleActive(item, pathname);
        const children = childKeys(item);
        const hasChildren = children.length > 0;

        return (
          <Tooltip
            key={item.key}
            title={item.label}
            placement="left"
          >
            <button
              type="button"
              aria-label={typeof item.label === "string" ? item.label : item.key}
              aria-current={active ? "page" : undefined}
              className={`${styles.item} ${active ? styles.itemActive : ""} ${
                openKey === item.key ? styles.itemOpen : ""
              } ${item.locked ? styles.itemLocked : ""}`}

              onClick={() => {
                if (item.locked) {
                  onLocked?.(item);
                  return;
                }
                if (hasChildren) onOpen(item.key);
                onNavigate(hasChildren ? children[0] : item.key);
              }}
            >
              <span className={styles.itemIcon}>{item.icon}</span>
              {item.locked && (
                <span className={styles.lockBadge} aria-hidden="true">
                  <CrownFilled />
                </span>
              )}
            </button>
          </Tooltip>
        );
      })}
    </div>

    <Tooltip title="خروج از حساب کاربری" placement="left">
      <button
        type="button"
        aria-label="خروج از حساب کاربری"
        className={`${styles.item} ${styles.logout}`}
        disabled={logoutLoading}
        onClick={onLogout}
      >
        <span className={styles.itemIcon}>
          <LogoutOutlined />
        </span>
      </button>
    </Tooltip>
  </nav>
);

export default NavRail;
